import { render, staticRenderFns } from "./ModalSuporteHospitalSla.vue?vue&type=template&id=52d7b90d&scoped=true"
import script from "./ModalSuporteHospitalSla.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteHospitalSla.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteHospitalSla.vue?vue&type=style&index=0&id=52d7b90d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d7b90d",
  null
  
)

export default component.exports